// Theme registry - the CSS custom property values for each theme live in
// styles/themes.css as `:root[data-theme="<id>"]` blocks. Adding a new theme is:
// (1) add an entry here, (2) add a matching block in themes.css. Nothing else
// needs to change - the picker UI and persistence are theme-agnostic.
export interface ThemeDefinition {
  id: string;
  label: string;
  isDark: boolean;
  /** Matches --bg / --accent in themes.css - duplicated here so the picker can draw
   * swatches without switching data-theme back and forth to sample computed styles. */
  previewBg: string;
  previewAccent: string;
}

// Both groups are ordered by the hue of their accent color (see previewAccent) so
// the picker reads as a smooth color wheel rather than an arbitrary list.
export const THEMES: ThemeDefinition[] = [
  { id: "ember", label: "Ember", isDark: true, previewBg: "#201513", previewAccent: "#ef6a4d" },
  { id: "amber", label: "Amber Dusk", isDark: true, previewBg: "#201a10", previewAccent: "#f2a53d" },
  { id: "forest", label: "Forest", isDark: true, previewBg: "#151f1b", previewAccent: "#59c98a" },
  { id: "slate", label: "Slate", isDark: true, previewBg: "#16191c", previewAccent: "#6fc3d1" },
  { id: "ocean", label: "Ocean Deep", isDark: true, previewBg: "#0f1c24", previewAccent: "#45c2e0" },
  { id: "midnight", label: "Midnight", isDark: true, previewBg: "#1b1d27", previewAccent: "#7c9bff" },
  { id: "indigo", label: "Indigo Night", isDark: true, previewBg: "#191a2e", previewAccent: "#9d84ff" },
  { id: "violet", label: "Violet Dream", isDark: true, previewBg: "#1a1425", previewAccent: "#c084fc" },
  { id: "crimson", label: "Crimson", isDark: true, previewBg: "#201417", previewAccent: "#ef6f8a" },
  { id: "linen", label: "Linen", isDark: false, previewBg: "#f4efe6", previewAccent: "#a56a3f" },
  { id: "sand", label: "Sand", isDark: false, previewBg: "#f7f1e0", previewAccent: "#d1a52e" },
  { id: "mint", label: "Mint", isDark: false, previewBg: "#eef7f2", previewAccent: "#2f9e73" },
  { id: "sky", label: "Sky", isDark: false, previewBg: "#eef4fa", previewAccent: "#3f7fc4" },
  { id: "lavender", label: "Lavender", isDark: false, previewBg: "#f3eef8", previewAccent: "#8a5fc4" },
  { id: "blush", label: "Blush", isDark: false, previewBg: "#faf0f2", previewAccent: "#c15f7c" },
];

export const DEFAULT_THEME_ID = "midnight";

export function isValidThemeId(id: string): boolean {
  return THEMES.some((t) => t.id === id);
}
